<h2 mat-dialog-title>{{ (isEditMode ? 'edit_dds_reference_tr' : 'add_dds_reference_tr') | translate }}</h2>

<mat-dialog-content>
  <form [formGroup]="ddsForm">
    <mat-form-field>
      <mat-label>{{ 'dds_reference2_tr' | translate }}</mat-label>
      <input matInput formControlName="ddr" />
      <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'ddv_validation_tr' | translate }}</mat-label>
      <input matInput formControlName="ddv" />
      <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'description_comment_tr' | translate }}</mat-label>
      <input matInput formControlName="comment" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'date_of_delivery_received_tr' | translate }}</mat-label>
      <input [matDatepicker]="dateReceivedDatePicker" formControlName="dateReceived" matInput placeholder="MM/DD/YYYY" />
      <mat-datepicker-toggle [for]="dateReceivedDatePicker" matIconSuffix></mat-datepicker-toggle>
      <mat-datepicker #dateReceivedDatePicker></mat-datepicker>
      <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'Tags_tr' | translate }}</mat-label>
      <!-- TODO switch to app-... component -->
      <mat-chip-grid #chipGrid [attr.aria-label]="'Enter_Article_Number_tr' | translate">
        @for (tag of tags; track tag) {
          <mat-chip-row (removed)="removeTag(tag)">
            {{ tag }}
            <button type="button" matChipRemove [attr.aria-label]="('Remove_tr' | translate) + ' ' + tag">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
        <input
          #input
          placeholder="{{ 'add_tag_tr' | translate }}..."
          [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="addTag($event, input)"
          (blur)="addPendingTag($event, input)"
        />
      </mat-chip-grid>
      <mat-hint>{{ 'type_a_tag_and_press_comma_or_enter_tr' | translate }}</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="cancel()">{{ 'cancel_tr' | translate }}</button>
  <button type="button" mat-flat-button color="primary" (click)="add()" [disabled]="!ddsForm.dirty || ddsForm.invalid">
    <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
    {{ (isEditMode ? 'update_dds_tr' : 'add_dds_tr') | translate }}
  </button>
</mat-dialog-actions>
